export const nutrientSourcesEN = {
  Spirits: "Spirits",
  Wine: "Wine",
  Beer: "Beer",
  "Flaxseed oil": "Flaxseed oil",
  "Chia seeds": "Chia seeds",
  "Hemp seeds": "Hemp seeds",
  "Canola oil": "Canola oil",
  "Soybean oil": "Soybean oil",
  Edamame: "Edamame",
  "Navy beans": "Navy beans",
  Avocados: "Avocados",
  "Wholemeal bread": "Wholemeal bread",
  Broccoli: "Broccoli",
  Spinach: "Spinach",
  "Red meat": "Red meat",
  "Organ meat": "Organ meat",
  "Brussel sprouts": "Brussel sprouts",
  Tomatoes: "Tomatoes",
  Peas: "Peas",
  "Brewer’s Yeast": "Brewer’s Yeast",
  "Beet root": "Beet root",
  Carrots: "Carrots",
  Sardines: "Sardines",
  Salmon: "Salmon",
  Eggs: "Eggs",
  Chicken: "Chicken",
  Pork: "Pork",
  Milk: "Milk",
  Seaweed: "Seaweed",
  "Leafy greens": "Leafy greens",
  "Sesame seeds": "Sesame seeds",
  "Poppy seeds": "Poppy seeds",
  "Celery seeds": "Celery seeds",
  Cheese: "Cheese",
  Yogurt: "Yogurt",
  Beans: "Beans",
  Lentils: "Lentils",
  Almonds: "Almonds",
  Whey: "Whey",
  "Spring greens": "Spring greens",
  Shellfish: "Shellfish",
  "Beef steak": "Beef steak",
  "Full-fat yogurt": "Full-fat yogurt",
  Beef: "Beef",
  "Fatty fish": "Fatty fish",
  Cauliflower: "Cauliflower",
  Oranges: "Oranges",
  Strawberries: "Strawberries",
  Legumes: "Legumes",
  Nuts: "Nuts",
  Seeds: "Seeds",
  Oils: "Oils",
  "Coffee beans": "Coffee beans",
  Cacao: "Cacao",
  "Kola nuts": "Kola nuts",
  "Green tea": "Green tea",
  Guarana: "Guarana",
  "Yerba mate tea": "Yerba mate tea",
  Oysters: "Oysters",
  "Shiitake mushrooms": "Shiitake mushrooms",
  Tofu: "Tofu",
  "Sweet potatoes": "Sweet potatoes",
  "Cashew nuts": "Cashew nuts",
  "Dark leafy greens": "Dark leafy greens",
  Chickpeas: "Chickpeas",
  Cocoa: "Cocoa",
  "Pork chops": "Pork chops",
  "Chicken breast": "Chicken breast",
  Tuna: "Tuna",
  Oatmeal: "Oatmeal",
  "Low-fat yogurt": "Low-fat yogurt",
  "Sunflower seeds": "Sunflower seeds",
  "Swiss cheese": "Swiss cheese",
  Trout: "Trout",
  Mussels: "Mussels",
  Cod: "Cod",
  "Fish roe": "Fish roe",
  Herring: "Herring",
  Clams: "Clams",
  Crab: "Crab",
  "Microalgae supplement": "Algal oil",
  "Forage fish": "Forage fish",
  "Algal oil": "Algal oil",
  Walnuts: "Walnuts",
  "Flax seeds": "Flax seeds",
  "Perilla oil": "Perilla oil",
  Berries: "Berries",
  Popcorn: "Popcorn",
  "Whole grains": "Whole grains",
  Apples: "Apples",
  "Dried fruits": "Dried fruits",
  Potatoes: "Potatoes",
  Asparagus: "Asparagus",
  "Citrus fruit": "Citrus fruit",
  "Beef liver": "Beef liver",
  "Wheat germ": "Wheat germ",
  Papayas: "Papayas",
  Bananas: "Bananas",
  "Fortified grains": "Fortified grains",
  "Fruit juices": "Fruit juices",
  "Soft drinks": "Soft drinks",
  Fruits: "Fruits",
  Honey: "Honey",
  "Fruit yogurt": "Fruit yogurt",
  "Apple pie": "Apple pie",
  Sauces: "Sauces",
  "Salad dressing": "Salad dressing",
  Wheat: "Wheat",
  Barley: "Barley",
  Rye: "Rye",
  Triticale: "Triticale",
  Oats: "Oats",
  Breads: "Breads",
  Cereals: "Cereals",
  Pasta: "Pasta",
  Rice: "Rice",
  "Chicken liver": "Chicken liver",
  "Pumpkin seeds": "Pumpkin seeds",
  Quinoa: "Quinoa",
  Turkey: "Turkey",
  Fish: "Fish",
  "Red kidney beans": "Red kidney beans",
  Butter: "Butter",
  "Ice-cream": "Ice-cream",
  Cream: "Cream",
  "Sour cream": "Sour cream",
  "Crème fraiche": "Crème fraiche",
  Batter: "Batter",
  "Pastries ": "Pastries ",
  Kale: "Kale",
  "Romaine lettuce": "Romaine lettuce",
  Corn: "Corn",
  "Bell peppers": "Bell peppers",
  Parsley: "Parsley",
  "Pistachio nuts": "Pistachio nuts",
  Guavas: "Guavas",
  Watermelon: "Watermelon",
  Grapefruits: "Grapefruits",
  "Red bell peppers": "Red bell peppers",
  Persimmon: "Persimmon",
  "Red cabbage": "Red cabbage",
  Mangos: "Mangos",
  Mackerel: "Mackerel",
  Halibut: "Halibut",
  "Blue mussels": "Blue mussels",
  "Brown rice": "Brown rice",
  "Lima beans": "Lima beans",
  Pineapple: "Pineapple",
  "Ricotta cheese": "Ricotta cheese",
  "Brazil nuts": "Brazil nuts",
  "White beans": "White beans",
  Tea: "Tea",
  Coffee: "Coffee",
  Juices: "Juices",
  "Soya beverages": "Soya beverages",
  "Beet greens": "Beet greens",
  Rhubarb: "Rhubarb",
  "Swiss chard": "Swiss chard",
  Chai: "Chai",
  Peanuts: "Peanuts",
  "Turnip greens": "Turnip greens",
  "Star fruit": "Star fruit",
  "Dairy products": "Dairy products",
  "Butter milk": "Butter milk",
  "Bottled coffee": "Bottled coffee",
  "Flavoured water": "Flavoured water",
  "Cereal bars": "Cereal bars",
  "Cottage cheese": "Cottage cheese",
  "Processed meats": "Processed meats",
  Hazelnuts: "Hazelnuts",
  "Rice bran": "Rice bran",
  Soybeans: "Soybeans",
  "Kidney beans": "Kidney beans",
  "Sunflower oil": "Sunflower oil",
  "Cottonseed oil": "Cottonseed oil",
  "Macadamia nuts": "Macadamia nuts",
  "Olive oil": "Olive oil",
  "Tomato juice": "Tomato juice",
  Mushrooms: "Mushrooms",
  Cucumbers: "Cucumbers",
  Zucchini: "Zucchini",
  Pumpkins: "Pumpkins",
  "Alcoholic drinks": "Alcoholic drinks",
  Anchovies: "Anchovies",
  Scallops: "Scallops",
  Haddock: "Haddock",
  Bacon: "Bacon",
  Veal: "Veal",
  Venison: "Venison",
  Duck: "Duck",
  Ham: "Ham",
  Lobster: "Lobster",
  Shrimp: "Shrimp",
  Coconut: "Coconut",
  "Palm kernel": "Palm kernel",
  Lamb: "Lamb",
  Mutton: "Mutton",
  "Cocoa butter": "Cocoa butter",
  "Shea butter": "Shea butter",
  "Baked beans": "Baked beans",
  "Table Salt": "Table Salt",
  "Cured ham": "Cured ham",
  "Pickled gherkin": "Pickled gherkin",
  "Canned beans": "Canned beans",
  "French bread": "French bread",
  "Teriyaki sauce": "Teriyaki sauce",
  Parmesan: "Parmesan",
  "Butternut squash": "Butternut squash",
  Cantaloupes: "Cantaloupes",
  Apricots: "Apricots",
  "Sugar beets": "Sugar beets",
  "Sugar cane": "Sugar cane",
  "Sweet peas": "Sweet peas",
  Peaches: "Peaches",
  "BBQ sauce": "BBQ sauce",
  Ketchup: "Ketchup",
  "Spaghetti sauce": "Spaghetti sauce",
  "Sport drinks": "Sport drinks",
  "Chocolate milk": "Chocolate milk",
  Granola: "Granola",
  "Flavored coffee": "Flavored coffee",
  "Iced tea": "Iced tea",
  "Protein bars": "Protein bars",
  "Canned soup": "Canned soup",
  "Breakfast cereal": "Breakfast cereal",
  "Canned fruit": "Canned fruit",
  "Premade smoothies": "Premade smoothies",
  "Sea buckthorn berries": "Sea buckthorn berries",
  Olives: "Olives",
  Peanut: "Peanut",
  Pecans: "Pecans",
  Rapeseed: "Rapeseed",
  "Black currant seeds": "Black currant seeds",
  Spirulina: "Spirulina",
  Chlorella: "Chlorella",
  "Fat-free milk": "Fat-free milk",
  "Sweet red peppers": "Sweet red peppers",
  "Black-eyed peas": "Black-eyed peas",
  Squash: "Squash",
  "Fortified oats": "Fortified oats",
  "Low-fat Milk": "Low-fat Milk",
  Liver: "Liver",
  "Soft cheese": "Soft cheese",
  "Kakadu plums": "Kakadu plums",
  "Acerola cherries": "Acerola cherries",
  "Rose hips": "Rose hips",
  "Chilli peppers": "Chilli peppers",
  "Sweet yellow peppers": "Sweet yellow peppers",
  Blackcurrants: "Blackcurrants",
  Thyme: "Thyme",
  "Mustard spinach": "Mustard spinach",
  Kiwis: "Kiwis",
  Lemons: "Lemons",
  Lychees: "Lychees",
  "American persimmons": "American persimmons",
  "Cod liver oil": "Cod liver oil",
  Soy: "Soy",
  "Oat milk": "Oat milk",
  "Egg yolks": "Egg yolks",
  "Cheddar cheese": "Cheddar cheese",
  "Wheat germ oil": "Wheat germ oil",
  "Safflower oil": "Safflower oil",
  "Peanut butter": "Peanut butter",
  Abalone: "Abalone",
  "Collard greens": "Collard greens",
  "Rainbow trout": "Rainbow trout",
  "Red sweet peppers": "Red sweet peppers",
  Meat: "Meat",
  "Green beans": "Green beans",
  Amaranth: "Amaranth",
  Millet: "Millet",
  Arrowroot: "Arrowroot",
  Buckwheat: "Buckwheat",
  Sorghum: "Sorghum",
  Tapioca: "Tapioca",
  Soya: "Soya",
  "Almond milk": "Almond milk",
  "Soya milk": "Soya milk",
  "Coconut milk": "Coconut milk",
  Margarine: "Margarine",
  "Rice milk": "Rice milk",
};
